module.exports = __webpack_public_path__ + "img/form_dingding.4bf5a3e6.png";